"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function competenceProgress(references, resolveCompletion) {
    const objectIds = references.map(x => x.objectId);
    const objectCompletions = resolveCompletion(objectIds);
    const sum = references.map(x => x.weight).reduce((a, b) => a + b, 0);
    const progress = references.map((x, index) => x.weight * objectCompletions[index])
        .reduce((a, b) => a + b, 0) / sum;
    return progress;
}
exports.competenceProgress = competenceProgress;
//# sourceMappingURL=competence-calculator.js.map